module.exports = __webpack_public_path__ + "img/product-mobile3.f4315ea9.png";